import store from "../store";


export const projectListSelectors = {
	content: (state = store.getState()) => state.projects.content,
	summary: (state = store.getState()) => state.projects.summary,
};
